<template>
  <div
    class="empty-state"
    :class="{
      'empty-state--outlined': outlined,
      'empty-state--big': big,
      'empty-state--huge': huge,
    }"
  >
    <v-btn
      class="empty-state__btn"
      tile
      fab
      dark
      small
      elevation="3"
      :color="color"
      @click.stop="addFeatures"
    >
      <v-icon dark class="empty-state__icon">mdi-plus</v-icon>
    </v-btn>
    <div class="empty-state__content">
      <h4 class="empty-state__title">
        {{ title }}
      </h4>
      <p class="empty-state__description">
        {{ description }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    outlined: {
      type: Boolean,
      required: false,
      default: false,
    },
    color: {
      type: String,
      required: false,
      default: 'blue',
    },
    big: {
      type: Boolean,
      required: false,
      default: false,
    },
    huge: {
      type: Boolean,
      required: false,
      default: false,
    },
    title: {
      type: String,
      required: false,
      default: 'Would you like to have more precise offers',
    },
    description: {
      type: String,
      required: false,
      default: 'Add as many of your skills as possible so more recruiters can find you.',
    },
  },

  methods: {
    addFeatures(event) {
      this.$emit('click', event);
    },
  },
};
</script>

<style lang="scss" scoped>
.empty-state {
  padding: 16px;
  display: flex;
  align-items: center;

  &--outlined {
    border: 1px dashed #E2E6EA;
    border-radius: 4px;
  }

  &__btn {
    border-radius: 8px;
  }

  &__content {
    margin-left: 24px;
  }

  &__title {
    font-size: 14px;
    line-height: 16px;
    letter-spacing: 0;
    color: #394657;
    margin-bottom: 8px;
  }

  &__description {
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0;
    color: #B9BEC4;
    margin-bottom: 0;
    max-width: 540px;
  }

  &--big {
    .empty-state__title {
      font-size: 18px;
      line-height: 21px;
    }
    .empty-state__description {
            font-size: 14px;
      line-height: 21px;
    }
  }

  &--huge {
    padding: 48px 64px;

    .empty-state__btn {
      width: 64px;
      height: 64px;
    }
    .empty-state__content {
      margin-left: 48px;
    }
    .empty-state__icon {
      font-size: 44px !important;
      color: $color--orange !important;
    }
    .empty-state__title {
      font-size: 18px;
      line-height: 21px;
    }
  }
}
</style>
